import {
	rewardTierList,
	rewardTierCreate,
	rewardTierUpdate,
	rewardTierDestroy,
	conversionList,
	grantList,
	grantRevoke,
} from '@/services/referrals.service'

export default {
	namespaced: true,
	state: {
		rewardTierList: { data: [], meta: { pagination: { total: 0 } } },
		conversionList: { data: [], meta: { pagination: { total: 0 } } },
		grantList: { data: [], meta: { pagination: { total: 0 } } },

		listStatus: 'init',
		saveStatus: 'init',
		deleteStatus: 'init',
	},
	getters: {
		getRewardTierList: s => s.rewardTierList,
		getConversionList: s => s.conversionList,
		getGrantList: s => s.grantList,
		getListStatus: s => s.listStatus,
		getSaveStatus: s => s.saveStatus,
		getDeleteStatus: s => s.deleteStatus,
	},
	mutations: {
		SET_REWARD_TIER_LIST(state, val) { state.rewardTierList = val },
		SET_CONVERSION_LIST(state, val) { state.conversionList = val },
		SET_GRANT_LIST(state, val) { state.grantList = val },
		SET_LIST_STATUS(state, val) { state.listStatus = val },
		SET_SAVE_STATUS(state, val) { state.saveStatus = val },
		SET_DELETE_STATUS(state, val) { state.deleteStatus = val },
	},
	actions: {
		// ─── Reward Tiers ───────────────────────────────
		async fetchRewardTierList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await rewardTierList(params)
				commit('SET_REWARD_TIER_LIST', data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
		async saveRewardTier({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = params.id ? await rewardTierUpdate(params) : await rewardTierCreate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_SAVE_STATUS', 'init')
				throw e
			}
		},
		async deleteRewardTier({ commit }, params) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				await rewardTierDestroy(params)
				commit('SET_DELETE_STATUS', 'init')
			} catch (e) {
				commit('SET_DELETE_STATUS', 'init')
				throw e
			}
		},

		// ─── Conversions ────────────────────────────────
		async fetchConversionList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await conversionList(params)
				commit('SET_CONVERSION_LIST', data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
		async fetchGrantList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await grantList(params)
				commit('SET_GRANT_LIST', data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
		async revokeGrant(_, { id, reason }) {
			return grantRevoke(id, reason)
		},
	},
}
